import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ChipButton',
  props: {
	selected: { type: Boolean, default: false },
	label: { type: String, required: true },
	disabled: { type: Boolean, default: false },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["chip-button", { 'chip-button--selected': __props.selected, 'chip-button--disabled': __props.disabled }]),
    disabled: __props.disabled
  }, _toDisplayString(__props.label), 11, _hoisted_1))
}
}

})